// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: "AIzaSyBx5Te-rq4JAKdeiCEkhMruTTxowTMBIFE",
  authDomain: "stream2025-d5333.firebaseapp.com",
  projectId: "stream2025-d5333",
  storageBucket: "stream2025-d5333.firebasestorage.app",
  messagingSenderId: "1025552231934",
  appId: "1:1025552231934:web:f955bea7aa967a5bafe4af",
  measurementId: "G-FRJLF6MVQN"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
